import { createPortal } from 'react-dom'
import usePortal from '@/hooks/use-portal'

 const Portal = ({ id, children }) => {
 	const target = usePortal(id);

	if (!target) {
		return null;
	}

 	return createPortal(
 		children,
 		target,
	)
 }

 export default Portal
